var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contanier"},[_c('div',{staticClass:"gongl-wrap"},[_c('div',{staticClass:"wrap",class:{ clickclose: _vm.ishide }},[_c('div',{staticClass:"close iconfont icon-close-line",on:{"click":_vm.hide}}),_c('div',{staticClass:"g-pic",on:{"click":_vm.goShow}},[_c('van-image',{attrs:{"src":_vm.gonglue,"fit":"cover"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }